///<reference path="../../../model/AppState.ts"/>

namespace khi.bk117.view.parts.card
{
	import EventDispatcher = com.enirva.event.EventDispatcher;
	import Sprite = com.enirva.display.Sprite;
	import Tween = com.enirva.tween.Tween;
	import UserAgent = com.enirva.util.UserAgent;
	import AppState = khi.bk117.model.AppState;

	/*
	 * WebGL表示後のカードUI制御クラス　
	 * 
	 * UserAgent.instance.isIE11を使ってるところは以下のバグ回避用の処理
	 * →カードアイテムの最後の２つだけ、マウスオーバーで枠がズレるなどのバグが発生
	 * →どうやっても回避できなかったので、IE11の場合はアイテム個数を２倍にして
	 * →最後の２つが画面上に出ないように工夫。
	 */
	export class CardController extends EventDispatcher
	{
		private readonly WIDTH_PC:number = 300;

		private readonly WIDTH_SP:number = 252;//210;
		
		private readonly MARGIN_PC:number = 120;

		private readonly MARGIN_SP:number = 30;

		//カードオブジェクト配列
		private cards:Card[];

		//カード間のマージン
		private margin:number;

		//アイテム幅
		private itemWidth:number;

		//操作不可フラグ
		private locked:boolean;

		//マウスイベント(PCとSPで異なる)
		private moveType:string;
		private downType:string;
		private upType:string;

		//現在のインデックス
		private currentIndex:number;

		//アイテムの最大数
		private maxNum:number;

		//タイマーのインターバルID
		private timerInterval:number;

		private modalEnterFrame:EventDispatcher;

		private slideMotionEnterFrame:EventDispatcher;


		constructor()
		{
			super();

			//$(".slideCardContainer").fadeIn(300);

			$(".btnOpenContainer .btnOpen").on("click", ()=>
			{
				//$(".slideCardModalContainer").fadeIn(300);
				this.openModal();
			});
			$(".slideCardModalContainer .btnClose").on("click", ()=>
			{
				//$(".slideCardModalContainer").fadeOut(300);
				this.closeModal();
			});

			//カードクリック時のイベントセット
			$(".slideCardModalContainer a.item").each((index:number, elem:Element):void=>
			{
				$(elem).on("click", ()=>
				{
					this.clickAt(index, true);
				});
			});

			this.modalEnterFrame = new EventDispatcher();
			this.slideMotionEnterFrame = new EventDispatcher();
			this.slideMotionEnterFrame.useDeltaTime = true;
		}


		/*
		 * 登場アニメーション
		 */
		public showCard():void
		{
			this.margin = this.MARGIN_PC;
			this.itemWidth = this.WIDTH_PC;

			if (UserAgent.instance.isSmartPhone)
			{
				this.moveType = "touchmove";
				this.downType = "touchstart";
				this.upType = "touchend";
			}
			else
			{
				this.moveType = "mousemove";
				this.downType = "mousedown";
				this.upType = "mouseup";
			}
			this.cards = [];

			//let copyCards:Card[] = [];

			if (UserAgent.instance.isIE11)
			{
				$(".slideCardContainer .card").each((index:number, elem:Element):void =>{
					const clone:JQuery = $(elem).clone();
					clone.addClass("cloneCard");
					$(".slideCardContainer .offsetY").append(clone);
				});
			}

			$(".slideCardContainer .card").each((index:number, elem:Element):void =>{
				const card:Card = new Card(elem, index);
				this.cards[index] = card;
			});
			
			/*
			$(".slideCardContainer .card").each((index:number, elem:Element):void =>{
				if (index < 2)
				{
					const clone:JQuery = $(elem).clone();
					clone.addClass("cloneCard");
					const card:Card = new Card(clone.get(0), index);
					card.spt.y = -200;
					card.spt.update();
					$(".slideCardContainer .offsetY").append(clone);
				}
			});
			*/
			

			if (UserAgent.instance.isIE11)
			{
				this.currentIndex = this.cards.length / 2;
			}
			else
			{
				this.currentIndex = 0;
			}

			/*
			for (var i:number = 0; i < copyCards.length; i++)
			{
				$(".slideCardContainer .offsetY").append(copyCards[i].element);
			}

			console.log(this.cards.length);
			*/

			this.maxNum = this.cards.length;
			
			$(".slideCardContainerBody").css("visibility", "visible");

			//this.startContents();

			//位置を初期化
			this.updatePosition(this.currentIndex);

			//リサイズイベントをセット
			AppState.addResizeFunc(this.onResize, this);
			this.onResize(true);

			//全体を表示
			$(".slideCardContainer").css({
				"visibility" : "visible"/*,
				"display" : "none"*/
			});
			//$(".slideCardContainer").fadeIn(500);

			function compareFunc(a:Card, b:Card) {
				return b.spt.x - a.spt.x;
			}
			 
			var tmp:Card[] = [];

			for (var i:number = 0; i < this.cards.length; i++)
			{
				tmp[i] = this.cards[i];
			}
			tmp.sort(compareFunc);
			 
			/*
			for (var i:number = 0; i < tmp.length; i++)
			{
				tmp[i].delay = i * 15;

				//console.log(tmp[i].index + " " +  tmp[i].delay);
			}*/

			let end_cc:number = 0;

			for (var i:number = 0; i < this.cards.length; i++)
			{
				this.cards[i].addEventListener("completeAnim", ()=>
				{
					//console.log(end_cc + " " + this.cards.length);
					if (++end_cc >= this.cards.length)
					{
						this.endShowAnim();
					}
				});
				this.cards[i].showMotion();
			}

			//PC用、モーダル展開時のスクロールを止める
			var scroll_event = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';

			window.addEventListener(scroll_event, (e:MouseEvent)=>{ this.doScroll(e); }, {passive:false});
			window.addEventListener("scroll", (e:MouseEvent)=>{ this.doScroll(e); }, {passive:false});
			//window.addEventListener("touchmove", (e:MouseEvent)=>{ this.doScroll(e); }, {passive:false});
			//window.addEventListener("keydown", (e:MouseEvent)=>{ this.doScroll(e); }, {passive:false});
			//this.endShowAnim();
		}


		/*
		 * アニメーション終了後の初期化
		 */
		private endShowAnim():void
		{
			//カードのドラッグイベントセット
			for (var i:number = 0; i < this.cards.length; i++)
			{
				this.setDragEvent(this.cards[i]);
			}

			//左右ボタンを出現
			$(".slideCardContainer .carouselButtons").fadeIn(300, ()=>
			{
				//左右ボタンのイベントセット
				$(".slideCardContainer .carouselButtons .btnLeft").on("click", ()=>
				{
					this.slideAt(-1);
				});
				$(".slideCardContainer .carouselButtons .btnRight").on("click", ()=>
				{
					this.slideAt(1);
				});
			});
			
			this.cards[this.currentIndex].onSelect();

			//タイマーを開始
			this.startTimer();
		}


		public onResize(isChange:boolean):void
		{
			if (isChange)
			{
				if (AppState.isSp)
				{
					this.itemWidth = this.WIDTH_SP;
					this.margin = this.MARGIN_SP;

				}
				else
				{
					this.itemWidth = this.WIDTH_PC;
					this.margin = this.MARGIN_PC;
				}

				this.updatePosition(this.currentIndex);
			}
		}


		/*
		 * カードクリック or モーダルからのクリック
		 */
		private clickAt(index:number, fromModal:boolean = false):void
		{
			//IE11対策で本来のカード数で割ったあまりが実際に飛ぶインデックスとなる
			index = index % 8;

			const scrollFunc:Function = ()=>
			{
				const sc:number = AppState.scrollPosition;
				const next_sc:number = $("#cardAnchor" + index).offset().top - 200;
				const diff:number = Math.abs(sc - next_sc);
				const sp:number = 500 + (diff * 0.1);
				$("html,body").stop(false, false).animate({scrollTop:$("#cardAnchor" + index).offset().top - 200}, sp);
			};

			if (fromModal)
			{
				this.closeModal();
	
				window.setTimeout(()=>
				{
					scrollFunc();
				}, 500);
			}
			else
			{
				scrollFunc();
			}
		}


		/*
		 * カードの配置
		 * 指定したインデックスのカードを基点として再配置する
		 * 指定インデックスのカードのみX座標を更新済の前提
		 */
		private updatePosition(baseIndex:number):void
		{
			this.cards[baseIndex].update();

			let flag:boolean = true;
			let curr:number = baseIndex;
			let currentPos:number;
			let cc:number = 1;
			const offset:number = this.cards[baseIndex].spt.x;

			const allWidth:number = this.cards.length * this.itemWidth + (this.cards.length * this.margin);

			do
			{
				if (++curr >= this.cards.length)
				{
					curr = 0;
				}

				const target:Card = this.cards[curr];

				let next:number = offset + (cc * (this.itemWidth + this.margin));

				if (next > 1500)
				{
					next -= allWidth;
				}
				else if (next < -1500)
				{
					next += allWidth;
				}

				target.spt.x = next;
				target.update();


				if (++cc >= this.cards.length)
				{
					flag = false;
				}

			} while(flag);
		}


		/*
		private sortForIE11():void
		{
			let flag:boolean = true;
			let curr:number = this.currentIndex;
			let cc:number = 0;

			do
			{
				const target:Card = this.cards[curr];

				target.element
				$(".slideCardContainer .offsetY").append(target.element);
				
				if (--curr < 0)
				{
					curr = this.cards.length - 1;
				}

				if (++cc >= this.cards.length)
				{
					flag = false;
				}

			} while(flag);
		}
		*/


		private updateIndexForIE11(baseIndex:number):void
		{
			Debugger.text(0, "base = " + this.currentIndex);
			if (baseIndex < 4)
			{
				baseIndex += 8;
				this.currentIndex = baseIndex;
			}
			else if (baseIndex > 11)
			{
				baseIndex -= 8;
				this.currentIndex = baseIndex;
			}
			Debugger.text(1, "base = " + this.currentIndex);
		}


		private removeCardSelect():void
		{
			for (var i:number = 0; i < this.cards.length; i++)
			{
				this.cards[i].unSelect();
			}
		}


		private checkCardVideo(currentIndex:number):void
		{
			/*
			for (var i:number = 0; i < this.cards.length; i++)
			{
				this.cards[i].videoCheck(i == currentIndex);
			}
			*/
		}


		/*
		 * １つ分スライドする
		 * indexは、1 or -1
		 */
		private slideAt(index:number):void
		{
			if (this.locked) 
			{
				return;
			}

			this.locked = true;
			this.stopTimer();
			this.removeCardSelect();
			
			const target:Card = this.cards[this.currentIndex];
			const end:number = -index * (this.itemWidth + this.margin);
			let sa:number = 0;
			let tmp:number;

			this.onEnterFrame = ()=>
			{
				sa += 0.015;
				target.spt.x += tmp = (end - target.spt.x)* sa;
				
				if (Math.abs(tmp) < 0.001)
				{
					target.spt.x = end;
					this.deleteEnterFrame;
					this.locked = false;
					//target.onSelect();

					let next:number = target.index + index;
					if (next < 0)
					{
						next = this.maxNum - 1;
					}
					else if (next >= this.maxNum)
					{
						next = 0;
					}

					this.currentIndex = next;

					if (UserAgent.instance.isIE11)
					{
						this.updateIndexForIE11(this.currentIndex);
					}

					this.cards[this.currentIndex].spt.x = 0;
					this.cards[this.currentIndex].spt.update();

					this.cards[this.currentIndex].onSelect();
					this.checkCardVideo(this.currentIndex);
					this.startTimer();

					target.update();
					this.updatePosition(this.currentIndex);
				}
				else
				{
					target.update();
					this.updatePosition(target.index);
				}
			};
		}


		/*
		 * 中心に一番近いカードのインデックスを取得
		 */
		private getNearestIndex():number
		{
			let index:number = -1;
			let nearDis:number = 9999;

			for (var i:number = 0; i < this.cards.length; i++)
			{
				//console.log(this.cards[i].index + " " + this.cards[i].spt.x);
				if (nearDis > Math.abs(this.cards[i].spt.x))
				{
					index = this.cards[i].index;
					nearDis = Math.abs(this.cards[i].spt.x);
				}
			}

			return index;
		}


		/*
		 * 自動切換えではなく、手動スクロールに(スマホ専用)
		 */
		private setDragEvent(target:Card):void
		{
			const touchStartHandler:Function = (e:TouchEvent):void=>
			{
				if (this.locked)
				{
					return;
				}

				this.locked = true;

				e.preventDefault();
				
				this.stopTimer();

				const mousePosition:{x:number, y:number} = AppState.getMousePosition(e);

				//中心X座標
				const center = window.innerWidth / 2;

				var offsetX:number = target.spt.x;
				var offsetTouchX:number = mousePosition.x;//e.touches[0].pageX;
				var offsetTouchY:number = mousePosition.y;//e.touches[0].pageY;
				var curr:number = offsetTouchX;

				//タッチ時は0で、タッチ終了すると1にする
				var sceneIndex:number = 0;
				var dragSpeed:number = 0;

				var nextIndex:number;
				var endFixedPos:number;

				let moveFunc:any;
				let endFunc:any;
				
				var isSide:boolean = false;
				var isWindowScroll:boolean = false;

				let isChange:boolean = false;

				let dragEndTarget:Card;

				let dragTime:number = 0;

				//タッチ終了時イベント
				window.addEventListener(this.upType, endFunc = (e2:TouchEvent)=>
				{
					//指が離れたので、どの写真にいくか判断

					AppState.scrollLock = false;

					if (AppState.isSp)
					{
						//SPの場合は加速度でチェック
						if (dragSpeed < -10)
						{
							nextIndex = this.currentIndex + 1;

							if (nextIndex >= this.maxNum)
							{
								nextIndex = 0;
							}
						}
						else if (dragSpeed > 10)
						{
							nextIndex = this.currentIndex - 1;

							if (nextIndex < 0)
							{
								nextIndex = this.maxNum - 1;
							}
						}
						else
						{
							nextIndex = this.currentIndex;
	
							//インデックスが変わらず、かつ短い時間しかドラッグしてないので
							//クリック判定とする
							if (dragTime < 10)
							{
								this.clickAt(target.index);
							}
						}
					}
					else
					{
						//PCの場合は距離で判定
						nextIndex = this.getNearestIndex();
					
						if (nextIndex == this.currentIndex)
						{
							//インデックスが変わらず、かつ短い時間しかドラッグしてないので
							//クリック判定とする
							if (dragTime < 10)
							{
								this.clickAt(target.index);
							}
						}
					}
					
					
					/*
					this.scrollWidth = (this.itemWidth * nextIndex) + (this.margin * (nextIndex));
					const per:number = -(this.scrollWidth / this.scrollTotalWidth);
					const w:number = this.itemWidth;//this.scrollContainer.element.width();


					endFixedPos = -this.scrollWidth;//per * w;
					*/

					//console.log(this.currentIndex + " " + nextIndex)

					if (this.currentIndex != nextIndex)
					{
						isChange = true;
						this.removeCardSelect();
					}

					this.currentIndex = nextIndex;

					dragEndTarget = this.cards[this.currentIndex];

					sceneIndex = 1;

					/*
					IE11はremoveEventListenerの際に第2引数にtrueが必要。
					ただtrueで統一してしまうと、Edgeのほうでremoveされないため
					IE11だけ例外処理でtrueを付与する
					*/
					if (UserAgent.instance.isIE11)
					{
						window.removeEventListener(this.moveType, moveFunc, true);
						window.removeEventListener(this.upType, endFunc, true);
					}
					else
					{
						window.removeEventListener(this.moveType, moveFunc);
						window.removeEventListener(this.upType, endFunc);
					}
				}, { passive : false });
				//-------------- touch end
				

				//タッチムーブイベント
				//最初の初動の位置によって、縦方向か横方向か、いずれかの動きに制限する

				//18.08.06 
				//passive : falseにしないとエラーが出るため
				//addEventListenerでイベントセット
				//jQueryのonだとpassiveの設定が出来ないようなので。
				//イベント削除は$().offで消えるっぽい
				window.addEventListener(this.moveType, moveFunc = (e3:TouchEvent)=>
				{
					if (isWindowScroll) 
					{
						return;
					}
					
					const mousePosition:{x:number, y:number} = AppState.getMousePosition(e3);

					if (isSide)
					{
						e3.preventDefault();
						
						curr = mousePosition.x;//e3.touches[0].pageX;
					}
					else
					{
						var moveX:number = mousePosition.x;//e3.touches[0].pageX;
						var moveY:number = mousePosition.y;//e3.touches[0].pageY;

						var r:number = Math.atan2(moveY - offsetTouchY, moveX - offsetTouchX) * 180 / Math.PI;
						if (r < 0)
						{
							r += 360;
						}
						if ((r < 45 || ((r > 135) && (r < 225)) || r > 315))
						{
							//水平方向に動いたのでカルーセル開始
							isSide = true;
							e.preventDefault();
							AppState.scrollLock = true;
							return false;
						}
						else
						{
							//垂直方向に動いたのでコンテンツスクロール開始
							isWindowScroll = true;
						}
					}
				}, { passive : false });

				var currX:number = curr;//offsetX + curr - offsetTouchX;

				var dragLimit:number = 70;
				var tmp:number;
				var sa:number = 0;

				const dragOffsetX:number = target.spt.x;

				const limitDragDis:number = 400;

				target.onEnterFrame = ():void =>
				{
					switch(sceneIndex)
					{
						case 0:
							//ドラッグ時のモーション
							dragSpeed = curr - currX;
							currX = curr;

							dragTime++;

							//Debugger.text(1, curr);

							let endMousePos:number = offsetX + (curr - offsetTouchX);
							let end:number;
							
							//Debugger.text(0, endMousePos + " " + dragOffsetX);

							let num:string;

							if ((Math.abs(endMousePos - dragOffsetX)) > 300)
							{
								num = "over 300";
								if (endMousePos > dragOffsetX)
								{
									end = limitDragDis + dragOffsetX;
								}
								else
								{
									end = -limitDragDis + dragOffsetX;
								}
							}
							else
							{
								num = "inner 300";
								end = ((endMousePos - dragOffsetX) / 300) * limitDragDis + dragOffsetX;
							}

							//Debugger.text(1, num + " " + end);

							target.spt.x += (end - target.spt.x) / 4;
							target.update();

							this.updatePosition(target.index);

							/*
							var per:number = Math.max(0, Math.min(1, (dragLimit - Math.abs(this.scrollContainer.x - offsetX)) / dragLimit));

							this.scrollContainer.x += dragSpeed * per;
							this.scrollContainer.update();
							*/
							break;
						case 1:
							//ドラッグ終了時の惰性

							sa += 0.015;
							dragEndTarget.spt.x += tmp = (0 - dragEndTarget.spt.x)* sa;
							
							if (Math.abs(tmp) < 0.001)
							{
								dragEndTarget.spt.x = 0;
								target.deleteEnterFrame;
								this.locked = false;
								this.startTimer();

								//console.log("isChange = " + isChange);

								if (UserAgent.instance.isIE11)
								{
									this.updateIndexForIE11(this.currentIndex);
								}

								dragEndTarget = this.cards[this.currentIndex];

								if (isChange)
								{
									dragEndTarget.onSelect();
								}

								dragEndTarget.spt.x = 0;
								dragEndTarget.update();
								this.updatePosition(dragEndTarget.index);
							}
							else
							{
								dragEndTarget.update();
								this.updatePosition(dragEndTarget.index);
							}
							/*
							sa += 0.015;
							this.scrollContainer.x += tmp = (endFixedPos - this.scrollContainer.x) * sa;

							if (Math.abs(tmp) < 0.001)
							{
								this.scrollContainer.x = endFixedPos;
								this.scrollContainer.deleteEnterFrame;
								this.startTimer();
								this.scrollContainer.update();
								this.checkLoopAjust(this.currentIndex);
							}
							else
							{
								this.scrollContainer.update();
							}
							*/

							break;
						default:break;
					}
				};
			};

			target.spt.element.on(this.downType, (e:JQueryEventObject)=>
			{
				touchStartHandler(e.originalEvent);
			});
		}


		private startTimer():void
		{
			//return;
			Debugger.text(0, "startTimer0");
			this.stopTimer();
			this.timerInterval = window.setTimeout(()=>
			{
				Debugger.text(0, "startTimer1");
				this.slideAt(1);
			}, 5000);
		}


		private stopTimer():void
		{
			window.clearTimeout(this.timerInterval);
		}


		/*
		 * モーダル開く
		 */
		private openModal():void
		{
			$(".btnOpenContainer").addClass("btnOpenHide");
			$(".slideCardModalContainer").addClass("slideCardModalContainerOpened");

			this.dontScroll = true;
			


			// スライドアイテムをリセットする
			/////////////////////////////////////////////////
			$(".slideCardModalContainer").find("h4, .item").removeClass("fadeIn");
			$(".slideCardModalContainer .btnClose").removeClass("btnCloseFadeIn");

			// スライドで登場する
			/////////////////////////////////////////////////
			window.setTimeout(()=>
			{
				let slideItems:{ target:JQuery, y:number, delay:number }[] = [];

				$(".slideCardModalContainer").find("h4, .item").each((index:number, elem:Element):void =>
				{
					//console.log(index + " = " + $(elem).offset().top);
					slideItems.push({
						target : $(elem),
						y : $(elem).offset().top,
						delay : 0
					});
				});

				function func(
					a:{ target:JQuery, y:number, delay:number }, 
					b:{ target:JQuery, y:number, delay:number }) 
				{
					return a.y - b.y;
				}

				slideItems.sort(func);

				let curr_y:number = slideItems[0].y;
				let delay:number = 0;

				for (var i:number = 0; i < slideItems.length; i++)
				{

					if (curr_y < slideItems[i].y)
					{
						delay += 100;
						curr_y = slideItems[i].y;
					}
					else
					{

					}
					slideItems[i].delay = delay;
				}
				
				//console.log(slideItems);

				let currIndex:number = 0;
				let curr = slideItems[currIndex];
				let interval:number = 0;

				this.slideMotionEnterFrame.onEnterFrame = (deltaTime:number):void =>
				{
					interval += deltaTime;

					if (interval >= curr.delay)
					{
						curr.target.addClass("fadeIn");

						if(++currIndex >= slideItems.length)
						{
							this.slideMotionEnterFrame.deleteEnterFrame;
							//console.log(">>>> end");

							$(".slideCardModalContainer .btnClose").addClass("btnCloseFadeIn");
						}
						else
						{
							curr = slideItems[currIndex];
						}
					}
				};
			}, 500);

			// End　スライドで登場する
			/////////////////////////////////////////////////

			//スマホ用、モーダル展開時はインナーだけスクロールさせる
			let touchEndFunc;

			window.addEventListener("touchstart", this.modalTouchStart, {passive:false});
			window.addEventListener("touchmove", this.modalTouchMove, {passive:false});
			/*
			window.addEventListener("touchend", touchEndFunc = (e)=>{
				window.removeEventListener("touchend", touchEndFunc);
				this.modalTouchEnd(e); 
			}, {passive:false});
			*/
			//let cc = 0;

			//開く時は位置をリセット
			CardController.modalDragOffsetY = 0;
			CardController.currentMouseY = 0;
			CardController.modalDragOffsetMouseY = 0;
			$(".slideCardModalContainer").scrollTop(0);

			this.modalEnterFrame.onEnterFrame = ()=>
			{
				//Debugger.text(2, ++cc + " " + CardController.modalDragOffsetY + " " + CardController.currentMouseY + " " +  CardController.modalDragOffsetMouseY);
				$(".slideCardModalContainer").scrollTop(CardController.modalDragOffsetY - (CardController.currentMouseY - CardController.modalDragOffsetMouseY));
			};
			/*
			var scroll_event = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';

			window.addEventListener(scroll_event, this.doScroll, {passive:false});
			window.addEventListener("scroll", this.doScroll, {passive:false});
			window.addEventListener("touchmove", this.doScroll, {passive:false});
			window.addEventListener("keydown", this.doScroll, {passive:false});
*/
			/*
			var movefun = function( event:Event )
			{
				console.log($(event.target).closest(".slideCardModalContainer").length);
			}
			
			// スクロール停止の処理
			window.addEventListener( 'touchmove' , movefun , { passive: false } );
			*/
		}


		private dontScroll:boolean;


		public static currentMouseY:number;

		public static modalDragOffsetY:number;

		public static modalDragOffsetMouseY:number;


		/*
		 * モーダル閉じる
		 */
		private closeModal():void
		{
			AppState.scrollLock = false;

			$(".btnOpenContainer").removeClass("btnOpenHide");
			$(".slideCardModalContainer").removeClass("slideCardModalContainerOpened");
			
			this.dontScroll = false;

			window.removeEventListener("touchstart", this.modalTouchStart);
			window.removeEventListener("touchmove", this.modalTouchMove);
			//window.removeEventListener("touchend", this.modalTouchEnd);
			this.modalEnterFrame.deleteEnterFrame;
			/*
			var scroll_event = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
			window.removeEventListener(scroll_event, this.doScroll);
			window.removeEventListener("scroll", this.doScroll);
			window.removeEventListener("touchmove", this.doScroll);
			window.removeEventListener("keydown", this.doScroll);
			*/
		}


		private modalTouchStart(e:TouchEvent):void
		{
			CardController.modalDragOffsetY = $(".slideCardModalContainer").scrollTop();
			CardController.modalDragOffsetMouseY = (e as TouchEvent).touches[0].pageY;
			CardController.currentMouseY = CardController.modalDragOffsetMouseY;

			//window.addEventListener("touchmove", this.modalTouchMove);

			/*
			this.onEnterFrame = ()=>
			{
				$(".slideCardModalContainer").scrollTop(offset - (CardController.currentMouseY - offsetMouseY));
			};
			*/
		}


		private modalTouchMove(e:TouchEvent):void
		{
			//Debugger.text(1, "> " + $(".slideCardModalContainer").scrollTop());
			CardController.currentMouseY = (e as TouchEvent).touches[0].pageY;
			//Debugger.text(0, "y = " + CardController.currentMouseY);
			e.preventDefault();
		}


		private modalTouchEnd(e:TouchEvent):void
		{
			this.deleteEnterFrame;
		}

		private doScroll(e:MouseEvent):void
		{
			if (this.dontScroll)
			{
				//console.log("dontScroll");
				e.preventDefault();
			}
		}

	}


	class Card extends EventDispatcher
	{
		public element:Element;

		public spt:Sprite;

		public index:number;

		public delay:number;

		private label:JQuery;

		private video:JQuery;

		private minScale;

		constructor(target:Element, index:number)
		{
			super();

			this.minScale = 0.7142857;
			this.element = target;
			
			this.spt = new Sprite($(target));
			this.spt.useDigit = true;
			this.spt.alpha = 0;
			//this.spt.setAnchor(50, 50);
			this.label = $(target).find(".block");
			this.index = index;
			//this.spt.x = -1600 + (index * 480);
			//this.spt.update();

			//<video src="img/movie0.mp4" playsinline muted autoplay loop></video>

			if ($(target).find("video").length)
			{
				this.video = $(target).find("video");
			}

			/*
			this.spt.rotation = 180;

			this.onEnterFrame = ():void =>
			{
				this.spt.rotation += (0 - this.spt.rotation) / 100;
				this.spt.updateWithRotY();
			};
			*/

			//this.onSelect();
		}


		public showMotion():void
		{
			const end_y:number = 0;
			this.spt.y = 150;
			this.spt.rotation = 120;
			this.spt.alpha = 0;
			//this.spt.scale = this.minScale;
			
			let sa:number = 0;
			let tmp:number;
			let sceneIndex:number = 0;
			let cc:number = 0;

			this.delay = 50 + (Math.abs(this.spt.x) / 28);

			if (this.delay > 100)
			{
				this.spt.rotation = 0;
				this.spt.y = end_y;
				this.spt.alpha = 1;
				this.spt.updateWithRotY();

				this.dispatchEvent({type:"completeAnim"});
			}
			else
			{
				this.onEnterFrame = ()=>
				{
					switch(sceneIndex)
					{
						case 0:
							if (++cc > this.delay)
							{
								sceneIndex = 1;
							}
							break;
						case 1:
							sa += 0.0065;
							this.spt.rotation += tmp = (0 - this.spt.rotation) * sa;
							this.spt.y += (end_y - this.spt.y) * sa;
							this.spt.alpha = Math.min(1, this.spt.alpha + 0.05);
							this.spt.updateWithRotY();
	
							if (this.index == 0)
							{
								//console.log(tmp);
							}
	
							if (Math.abs(tmp) < 0.05)
							{
								this.deleteEnterFrame;
								this.spt.rotation = 0;
								this.spt.y = end_y;
								this.spt.alpha = 1;
								this.spt.updateWithRotY();
	
								this.dispatchEvent({type:"completeAnim"});
							}
							break;
						default:break;
					}
				};
			}
		}


		/*
		 * 初回の登場モーション
		 */
		public showMotionOld():void
		{
			if (this.index > 0)
			{
				//return;
			}

			const end_x:number = this.spt.x;
			const end_scale:number = this.minScale;
			this.spt.x = -500;
			this.spt.alpha = 0;
			this.spt.rotation = -45;
			this.spt.scale = 0.3;//this.minScale;
			this.spt.updateWithRotY();

			let sa:number = 0;
			let tmp:number;

			let sceneIndex:number = 0;
			let cc:number = 0;
			let r:number = 4.3;
			const delay:number = this.delay;//(end_x - this.spt.x + 1700) / 20;

			const end_r:number = 6.8
			let sp:number;

			let motion_per:number = 0;
			//x2 = x1 * cos(α) - y1 * sin(α)
			//y2 = x1 * sin(α) + y1 * cos(α)

			//123 - 126

			let rotateBaseX:number;

			if (end_x > 0)
			{
				rotateBaseX = end_x - 600;
			}
			else
			{
				rotateBaseX = end_x - 600;
			}
			
			this.onEnterFrame = ()=>
			{
				switch(sceneIndex)
				{
					case 0:
						if (++cc > delay)
						{
							sceneIndex = 1;
						}
						break;
					case 1:
						r += 0.08;
						const next:number = Math.sin(r) * 300 + rotateBaseX;
						sp = next - this.spt.x;
						this.spt.x = next;
						this.spt.scale = Math.cos(r) * 0.2 + 0.6;
						this.spt.rotation = r * 180 / Math.PI;
						this.spt.alpha = Math.min(1, this.spt.alpha + 0.05);
						this.spt.updateWithRotY();

						Debugger.text(0, r);
						//Debugger.text(0, Math.sin(r));
						//Debugger.text(1, Math.cos(r));

						if (r > end_r)
						{
							sceneIndex = 2;
							this.spt.rotation = this.spt.rotation % 360;
						}

						break;
					case 2:
						sp *= 0.98;
						sa += 0.0015;
						const m1:number = this.spt.x + sp;
						const m2:number = this.spt.x + (end_x - this.spt.x) * sa;
						this.spt.x = (m1 * (1 - motion_per)) + (m2 * motion_per);
						motion_per = Math.min(1, motion_per + 0.02);
						//this.spt.x += sp;
						this.spt.rotation += tmp = (0 - this.spt.rotation) * sa;
						this.spt.scale += (end_scale - this.spt.scale) / 4;//* sa;

						this.spt.updateWithRotY();

						if (Math.abs(end_x - this.spt.x) < 0.05)
						{
							this.deleteEnterFrame;
							this.spt.rotation = 0;
							this.spt.x = end_x;
							this.spt.scale = end_scale;
							this.spt.updateWithRotY();
						}
						break;
					case 3:
						sa += 0.0035;
						this.spt.rotation += tmp = (0 - this.spt.rotation) * sa;
						this.spt.x += (end_x - this.spt.x) * sa;
						this.spt.alpha = Math.min(1, this.spt.alpha + 0.05);
						this.spt.scale += (end_scale - this.spt.scale) * sa;
						this.spt.updateWithRotY();
		
						if (this.index == 0)
						{
							//console.log(tmp);
						}
		
						if (Math.abs(tmp) < 0.05)
						{
							this.deleteEnterFrame;
							this.spt.rotation = 0;
							this.spt.x = end_x;
							this.spt.scale = end_scale;
							this.spt.updateWithRotY();
						}
						break;
					default:break;
				}
			};
		}


		public onSelect():void
		{
			this.spt.element.addClass("cardOpen");
		}

		public unSelect():void
		{
			this.spt.element.removeClass("cardOpen");
		}

		public videoCheck(isOn:boolean):void
		{
			if (this.video)
			{
				if (isOn)
				{
					this.video.fadeIn(300);
				}
				else
				{
					this.video.fadeOut(300);
				}
			}
		}

		public update():void
		{
			const maxScale:number = 1;
			const dis:number = Math.abs(this.spt.x);
			const threshold:number = 420;

			if (dis < threshold)
			{
				this.spt.scale = maxScale - (maxScale - this.minScale) * (dis / threshold);
				//this.spt.scale = 0.7142857;
			}
			else
			{
				//0.7142857142857143
				//0.7142857
				//this.spt.scale = ‭‬23;
				this.spt.scale = 0.7142857;
			}

			this.spt.update();
		}
	}
}

